import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const PreventBackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const preventBack = (e) => {
      e.preventDefault();
      window.history.pushState(null, '', window.location.href);
    };

    // Check if user is authenticated
    const userType = sessionStorage.getItem('usertype');
    const token = sessionStorage.getItem('usertoken');
    
    // Only prevent back button on main dashboard pages
    const mainDashboardPages = ['/config_admin', '/sales_admin', '/staff'];
    const isMainDashboard = mainDashboardPages.includes(location.pathname);
    
    if (!token) {
      navigate('/login');
      return;
    }

    if (isMainDashboard) {
      // Add initial history state
      window.history.pushState(null, '', window.location.href);
      // Add event listener
      window.addEventListener('popstate', preventBack);
    }

    // Cleanup
    return () => {
      if (isMainDashboard) {
        window.removeEventListener('popstate', preventBack);
      }
    };
  }, [navigate, location]);

  return null;
};

export default PreventBackButton; 